import { stringReplacer as n } from "../../../../utils/helpers.js";
import { FieldControllerErrorMessages as e } from "../FieldController.types.js";
const d = (a, r, t, o = "") => {
  if (a)
    return a;
  const i = r ? n(
    e[r] ?? e.validate,
    [
      {
        name: "{{attrValue}}",
        value: String(t == null ? void 0 : t[r])
      }
    ]
  ) : e.validate;
  return `${o}${i}`;
};
export {
  d as getErrorTypeMessage
};
